module.exports = __webpack_public_path__ + "img/morgana.cc686237.png";